import EmailNotificationBaseService from 'services/notification/subServices/email/EmailNotificationBaseService';

import SubmissionAcceptedEmailNotification from 'models/notification/email/SubmissionAcceptedEmailNotification';

export default class SubmissionAcceptedEmailNotificationService extends EmailNotificationBaseService {
	toModel(notification) {
		return new SubmissionAcceptedEmailNotification(notification);
	}
}
